import { downloadChatAsync, downloadDocumentAsync } from '../features/chat/chatThunk';
import { downloadProposalDocumentAsync } from '../features/proposalDocument/proposalDocumentThunk';
const signatures = {
    JVBERi0: 'application/pdf',
    R0lGODdh: 'image/gif',
    R0lGODlh: 'image/gif',
    iVBORw0KGgo: 'image/png',
    '/9j/': 'image/jpg',
    UEsDB: 'application/vnd.openxmlformats-officedocument'
};
export const getMimeTypeFromBase64 = (base64String) => {
    for (var s in signatures) {
        if (base64String.indexOf(s) === 0) {
            return signatures[s];
        }
    }
};
export const getMimeTypeFromBase641 = (base64String) => {
    const mimeType = base64String.split(',')[0].split(';')[0].split(':')[1];
    return mimeType;
};
export const convertBase64toBlob = (content, contentType) => {
    contentType = contentType || '';
    var sliceSize = 512;
    var byteCharacters = window.atob(content); //method which converts base64 to binary
    var byteArrays = [];
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    var blob = new File(byteArrays, 'aa', { type: contentType }); //statement which creates the blob
    return blob;
};
export const convertBase64ToBinary = (dataURI, filename) => {
    const arr = dataURI.split(',');
    var mime = getMimeTypeFromBase641(dataURI);
    var bstr = window.atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
};
export const convertToPdfFile = (fileString) => {
    const byteCharacters = atob(fileString);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    return blob;
};
export const convertToFile = (fileString) => {
    const base64Marker = ';base64,';
    const base64Index = fileString.indexOf(base64Marker);
    if (base64Index !== -1) {
        fileString = fileString.substring(base64Index + base64Marker.length);
    }
    const byteCharacters = atob(fileString);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'image/png' });
    return blob;
};
export const convertUrlFileToPDF = (fileName, folderName, dispatch) => {
    const fileDto = { folderName: folderName, fileName: fileName };
    dispatch(downloadProposalDocumentAsync(fileDto))
        .unwrap()
        .then((res) => {
        const mimeType = getMimeTypeFromBase64(res.file);
        if (mimeType === 'application/pdf') {
            // Preview the PDF in a new tab
            const mimeType = getMimeTypeFromBase64(res.file);
            const pdfWindow = window.open();
            pdfWindow?.document.write(`<title>${folderName} Document</title>`);
            pdfWindow?.document.write(`<iframe width='100%' height='100%' src='data:${mimeType};base64,${encodeURI(res.file)}'></iframe>`);
        }
        else {
            const blob = convertBase64toBlob(res.file, mimeType ?? '');
            if (!blob) {
                console.error('Failed to create Blob from the base64 string.');
                return;
            }
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName || 'download';
            link.click();
            URL.revokeObjectURL(url);
        }
    })
        .catch(() => { });
};
export const viewPdf = (proposalId, conversationId, clientName, dispatch) => {
    const request = { ProposalId: proposalId, ConversationId: conversationId };
    dispatch(downloadDocumentAsync(request))
        .unwrap()
        .then((res) => {
        const mimeType = getMimeTypeFromBase64(res.pdf);
        if (mimeType === 'application/pdf') {
            // Preview the PDF in a new tab
            const mimeType = getMimeTypeFromBase64(res.pdf);
            const pdfWindow = window.open();
            pdfWindow?.document.write(`<title>${clientName}_Proposal</title>`);
            pdfWindow?.document.write(`<iframe width='100%' height='100%' src='data:${mimeType};base64,${encodeURI(res.pdf)}'></iframe>`);
        }
    })
        .catch(() => { });
};
export const downloadDocx = (proposalId, conversationId, clientName, dispatch) => {
    const request = { ProposalId: proposalId, ConversationId: conversationId };
    dispatch(downloadDocumentAsync(request))
        .unwrap()
        .then((res) => {
        const mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        const blob = convertBase64toBlob(res.docx, mimeType ?? '');
        if (!blob) {
            console.error('Failed to create Blob from the base64 string.');
            return;
        }
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${clientName}_Proposal` || 'download';
        link.click();
        URL.revokeObjectURL(url);
    })
        .catch(() => {
    });
};
// export const downloadPdf = (
//   proposalId: string,
//   conversationId: string,
//   documentType: string,
//   dispatch: AppDispatch
// ): void => {
//   const request = { ProposalId: proposalId, ConversationId: conversationId } as DownloadChatRequest;
//   dispatch(downloadChatAsync(request))
//     .unwrap()
//     .then((res) => {
//       const mimeType = 'application/pdf';
//       const blob = convertBase64toBlob(res.pdfBase64, mimeType ?? '');
//       console.log(blob);
//       if (!blob) {
//         console.error('Failed to create Blob from the base64 string.');
//         return;
//       }
//       const url = URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.click();
//       URL.revokeObjectURL(url);
//     })
//     .catch(() => {});
// };
export const downloadPdf = (proposalId, conversationId, documentType, dispatch) => {
    const request = { ProposalId: proposalId, ConversationId: conversationId };
    dispatch(downloadChatAsync(request))
        .unwrap()
        .then((res) => {
        const mimeType = 'application/pdf';
        const blob = convertBase64toBlob(res.pdfBase64, mimeType);
        if (!blob) {
            console.error('Failed to create Blob from the base64 string.');
            return;
        }
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${conversationId || 'document'}.pdf`; // Sets the filename
        document.body.appendChild(link); // Append to body to ensure it works in all browsers
        link.click();
        document.body.removeChild(link); // Clean up
        URL.revokeObjectURL(url); // Free memory
    })
        .catch(() => { });
};
